const form = {
  formId: "new-user-form",
  formField: {
    taxCalculationPeriod: {
      name: "taxCalculationPeriod",
      label: "[01] Kỳ tính thuế:",
      type: "number",
      placeholder: "01/2023",
      errorMsg: "Vui lòng chọn kỳ tính thuế",
    },
    taxCalculationPeriodEnd: {
      name: "taxCalculationPeriodEnd",
      label: "Đến ngày:",
      type: "number",
      placeholder: "01/2023",
      errorMsg: "Vui lòng chọn kỳ tính thuế",
    },
    firstTime: {
      name: "firstTime",
      label: "[02] Lần đầu:",
      type: "text",
    },
    supplementaryForThe: {
      name: "supplementaryForThe",
      label: "[03] Bổ sung lần thứ:",
      type: "number",
      placeholder: "Chọn",
      errorMsg: "Vui lòng nhập bổ sung lần thứ",
      invalidMsg: "Số không hợp lệ",
    },
    hightIncomeBusiness: {
      name: "hightIncomeBusiness",
      label: "[04] Ngành nghề có tỷ lệ doanh thu cao nhất:",
      type: "text",
      placeholder: "Chọn",
      errorMsg: "Vui lòng chọn ngành nghề",
    },
    percent: {
      name: "percent",
      label: "[05] Tỷ lệ (%):",
      type: "number",
      placeholder: "Chọn",
      errorMsg: "Vui lòng nhập tỷ lệ",
      invalidMsg: "Số không hợp lệ",
    },
    taxpayerName: {
      name: "taxpayerName",
      label: "[06] Tên người nộp thuế",
      type: "text",
      placeholder: "Chọn",
      errorMsg: "Vui lòng nhập tên người nộp thuế",
    },
    taxId: {
      name: "taxId",
      label: "[07] Mã số thuế:",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập mã số thuế",
      invalidMsg: "Mã số thuế không hợp lệ",
    },
    taxAgentName: {
      name: "taxAgentName",
      label: "[08] Tên đại lý thuế (nếu có):",
      type: "text",
      placeholder: "",
    },
    taxAgentId: {
      name: "taxAgentId",
      label: "[09] Mã số thuế:",
      type: "text",
      placeholder: "",
    },
    contract: {
      name: "contract",
      label: "[10] Hợp đồng đại lý thuế: Số:",
      type: "text",
      placeholder: "",
    },
    contractDate: {
      name: "contract",
      label: "Ngày",
      type: "number",
      placeholder: "",
    },
    //--------------//
    fullName: {
      name: "fullName",
      label: "Họ và tên",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập mst đại lý",
    },
    certificate: {
      name: "certificate",
      label: "Chứng chỉ hành nghề số:",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập chứng chỉ hành nghề số",
    },
    signer: {
      name: "signer",
      label: "Người ký",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập người ký",
    },
    timeSign: {
      name: "timeSign",
      label: "Ngày ký",
      type: "number",
      placeholder: "",
      errorMsg: "Vui lòng chọn ngày ký",
    },
  },
};

export default form;
